import React from 'react'
import { Link } from 'react-router-dom'
import FooterPlaceholder from './FooterPlaceholder'

import 'loyal-design-system/assets/css/molecules/footer.css'

import logo from 'loyal-design-system/assets/images/brand/logo_ltm_bg_dark.svg'
import play from 'loyal-design-system/assets/images/google-play.svg'
import appStore from 'loyal-design-system/assets/images/app-store.svg'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import IuppContactList from './IuppContactList'
import yn from 'yn'

const items = [
  {
    path: `https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/regulation`,
    label: 'Regulamentos',
    order: 0,
    enable: process.env.RAZZLE_HAS_REGULATION_LINK
  },
  {
    path: `https://www.${process.env.RAZZLE_APP_TENANT_DOMAIN}/security`,
    label: 'Segurança',
    order: 1,
    enable: process.env.RAZZLE_HAS_SECURITY_LINK
  },
  {
    path: `https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/privacy`,
    label: 'Política de Privacidade',
    order: 2,
    enable: process.env.RAZZLE_HAS_PRIVACY_LINK
  },
  {
    path: `https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/terms`,
    label: 'Termos de uso',
    order: 3,
    enable: process.env.RAZZLE_HAS_TERMS_LINK
  },
  {
    path: `https://www.${process.env.RAZZLE_APP_TENANT_DOMAIN}/redirect/faq`,
    label: 'Ajuda',
    order: 4,
    enable: process.env.RAZZLE_HAS_FAQ_LINK
  },
  {
    path: `https://${process.env.RAZZLE_APP_TENANT_DOMAIN}/redirect/contact`,
    label: 'Fale Conosco',
    order: 5,
    enable: process.env.RAZZLE_HAS_CONTACT_LINK
  }
]

const Footer = () => (
  <ReactPlaceholder ready customPlaceholder={<FooterPlaceholder />}>
    <footer id='footer' className='box-footer d-none d-md-block'>
      <div className='container-footer footer-part-1 container-fluid py-4 d-none'>
        <div className='container py-1'>
          <div className='row'>
            <div className='address col-12 col-md-6 align-self-center'>
              <div className='row'>
                <div className='col-12 col-md-3 pl-0 pr-2 txt-center'>
                  <img src={logo} className='address-logo' alt={process.env.RAZZLE_TITLE || ''} />
                </div>
                <div className='col-12 col-md-8 align-self-center mt-3 mt-md-0'>
                  <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                    Alameda Rio Negro, 585 - 13º andar
                  </p>
                  <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                    Alphaville - Barueri - SP - CEP 06454-000
                  </p>
                </div>
              </div>
            </div>
            <div className='app col-12 col-md-6 d-none'>
              <div className='row'>
                <div className='col-12 col-md-6 txt-right downloadit-app txt-circular-book color-ui-white txt-center txt-md-right mt-3 mt-md-0 align-self-center'>
                  <span className='txt-customsize-20x28 d-block'>Baixe agora o app.</span>
                </div>
                <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                  <img
                    className='img-h-100 img-w-auto google-play'
                    src={play}
                    alt='Baixe o aplicativo no Google play'
                  />
                </div>
                <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                  <img
                    className='img-h-100 img-w-auto app-store'
                    src={appStore}
                    alt='Baixe o aplicativo na App Store'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container-footer footer-part-2 container-fluid'>
        <div className='container'>
          {yn(process.env.RAZZLE_FOOTERIUPP) ? (
            <IuppContactList />
          ) : (
            <div className='row'>
              <nav className='links col-12 px-0 py-3' role='navigation'>
                <ul className='row'>
                  {items.map(
                    (item, indexItem) =>
                      item.enable === 'true' && (
                        <li className='col col-md-auto pr-4 txt-center txt-md-left my-1 my-md-0'>
                          <a target='_blank' className='color-ui-white txt-body-sm' href={item.path}>
                            {item.label}
                          </a>
                        </li>
                      )
                  )}
                </ul>
              </nav>
            </div>
          )}
          <div className='row mx-0 px-0'>
            <div className='legal col-10 px-0 py-3'>
              <p className='color-ui-white txt-subtitle txt-center txt-md-left'>
                {process.env.RAZZLE_MESSAGE_FOOTER_LEGAL || 'Web Prêmios Comécio e serviços Promocionais Ltda. - CNPJ: 08.845.775/0001-70 - Inscrição Estadual: 206.247.436.112'}
              </p>
              <p className='color-ui-white txt-subtitle txt-center txt-md-left'>
                {
                  process.env.RAZZLE_MESSAGE_FOOTER_LEGAL_TEXT || `
                    O catálogo de prêmios é atualizado periódica e automaticamente pelos parceiros e os produtos 
                    e preços poderão sofrer alterações durante a navegação, 
                    sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate.
                `}
              </p>
            </div>
            {!yn(process.env.RAZZLE_FOOTERIUPP) && (
              <div
                className='address col-2 align-self-center txt-center logo-footer'
                role='img'
                aria-label={process.env.RAZZLE_TITLE || ''}
              />
            )}
          </div>
        </div>
      </div>
    </footer>
  </ReactPlaceholder>
)

export default Footer
